import React, { useState, useEffect } from "react";
import Tag from "../../../../generic/tag";
import ObCheckbox from "../../generic/obCheckbox";
import { IEqSip, IEquity } from "../../../../types/components/orderBook/obTypes";
import "../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsMob.scss";
import ObUtilHeader from "../../obContainer/obUtilHeader";
import moment from "moment";
import dateTimeFormat, { GetNoOfDaysOrMonths } from "../../../../service/dateTimeService";
import TocNoData from "../../../generic/tocNoData/tocNoData";
import { ChipColorKeyComb, scrlStCls, ObScrollStyle } from "../../obConstants";
import obtradeRowSelection from "../../../../service/orderBook/selectAll";
import { HObGroupBy, HOb2DGroupBy } from "../../../../service/orderBook/obGrpByHelper";
import DatePickerInt from "../../obContainer/obDatePickerInt";
import ObEqDtlsOpenMob from "../../obDetails/mob/obEqDtlsOpenMob";
import ObAssetDetailPopup from "../../generic/obAssetDetailPopup";
import { toINR } from "../../../../service/numberFormat";
import EdButton from "../../../../generic/edButton";
import { backButtonValue } from "../../obJsXConstants";
import "../../../../../assets/scss/components/toc/orderBook/obEquity/obEquityMob.scss";
import { ChipStatusComb } from "./../../obConstants";
import { AEqCancelNrmTrd, AEqCancelSIPOrd, AEqCancelAmoTrd } from "./../../../../service/orderBook/obApiService";

import ObToastMessPopup from "../../generic/obToastMessPopup";
import indexer from "../../../../types/genericTypes";
import { SearchHighLight } from "../../../../service/generic/searchHighlight";
import ee from "../../../../utils/eventEmitter";
import { numValChk } from "../../../../service/generic/numValueChk";

export interface IObEquityMobProps {
	// Array of Equity Data
	data: Array<any>;
	//true if table is history type else false
	isHistory?: boolean;
	hidePageNav?: (hide: boolean) => void;
	getDates: (frmDt: Date, toDate: Date) => void;
	isSip: boolean;
	aType: string;
	reRenderCall?: (value: string) => void;
}
const ObEquityMob: React.FC<IObEquityMobProps> = (props) => {
	const [isSelectEnable, setIsSelectEnable] = useState(false);

	const [isAllDataSelected, setIsAllDataSelected] = useState(false);

	// wherever initial data needs to be sent, send initialData
	// initial data is array of array for supporting grouping
	const initialData = [props.data.map((data, index) => ({ ...data, id: index, isSelected: false }))];

	// filteredData contains filtered, searched data
	// let filteredData: Array<any> = initialData;

	// tableData is shown in the table
	// tableData contains sorted, filtered, searched data
	let [tableData, setTableData] = useState(initialData);
	let eqHistoryData: Array<{ [x: string]: Array<IEquity> }> = [{}];

	// this function excute on clicking any row
	// date is passed only in the case of history
	function onRowClick(data: any, groupIndex: number, index: number, e?: any) {
		//each row contains two different native events, one of overflow and other is of checkbox
		if (
			e &&
			!e.nativeEvent.path.find((m: HTMLElement) => m.className && (m.className.indexOf("check") >= 0 || m.className.indexOf("menu") >= 0))
		) {
			setPopupDataIndex([groupIndex, index, props.isHistory ? data.ordEntTyp.split(" ")[0] : undefined]);
		}
	}
	//executed orders count
	const exeCountRef = React.useRef();
	//Show Open Ords on Top or not ref state
	const OpenOrdsTopRef = React.useRef<boolean>();
	useEffect(() => {
		setTableData([props.data]);
		//ref to initial toggle state of show open orders on top
		OpenOrdsTopRef.current = true;
		// check that props.data is not undefined/null, group it(open and others) and update tabledata

		if (props.data) {
			if (!props.isHistory && !props.isSip && OpenOrdsTopRef.current) {
				let temp0 = HOb2DGroupBy(props.data, "sts");
				exeCountRef.current = temp0[1].length;

				setTableData(temp0);
			}
		}

		return () => {
			setTableData([[{}]]);
		};
	}, [props.data, props.isHistory, props.isSip]);
	//kept outside because state data updating in async mode
	if (props.isHistory && props.data.length) {
		eqHistoryData = tableData.map((group) => HObGroupBy(group, "ordEntTyp", " "));
	}

	//selected count
	const [selectedCount, setselectedCount] = useState<number>(0);
	//is popup data
	const [popupDataIndex, setPopupDataIndex] = React.useState<[number, number, string?]>();

	// show cancel popup
	const [showCancelPopup, setShowCancelPopup] = React.useState<{ bulkCancel: boolean; data?: any }>();

	const selectRows = (groupIndex: number, index: number) => {
		const retRes = obtradeRowSelection(groupIndex, index, tableData, isAllDataSelected, "cancel", "true");

		// set the state
		setTableData(retRes.data);
		setselectedCount(retRes.count);

		setIsAllDataSelected(retRes.allSelected);
	};

	function onDataFilter(data: Array<any>, sText?: string, type?: string) {
		// filteredData = data;
		//highlightes the search text
		if (sText) {
			const SearchText: string = sText.toLowerCase();
			const searchKeys: string = "cpName;dpName;symName;trdSym;tSym";

			data[0].forEach((ord: indexer) => {
				searchKeys.split(";").forEach((k: string) => {
					if (ord[k]) {
						ord[k] = SearchHighLight(ord[k], SearchText);
					}
				});
			});
		}
		if (type === "search" && OpenOrdsTopRef.current && !props.isHistory && !props.isSip) {
			setTableData(HOb2DGroupBy(data[0], "sts"));
		} else {
			setTableData(data);
		}
	}

	function addFlAndNtQty(bulkCancel: boolean, data?: IEquity) {
		let flQtySum = 0;
		let ntQtySum = 0;

		if (bulkCancel) {
			tableData.forEach((g: any) =>
				g.forEach((rw: IEquity) => {
					if (rw.isSelected) {
						flQtySum += +rw.flQty;
						ntQtySum += +(rw.ntQty ? rw.ntQty : rw.qtyTF || 0);
					}
				})
			);
		} else if (data) {
			flQtySum += +data.flQty;
			ntQtySum += +(data.ntQty ? data.ntQty : data.qtyTF || 0);
		}

		return { flQtySum, ntQtySum };
	}

	function selectedRows(bulkCancel: boolean, data?: IEquity) {
		if (bulkCancel) {
			let total = 0;
			tableData.forEach((g: any) =>
				g.forEach((rw: IEquity) => {
					if (rw.isSelected) {
						total++;
					}
				})
			);
			return total;
		} else if (data) {
			return 1;
		}
		return 0;
	}

	let ordCancelledSuccList: Array<string> = [],
		ordCancelledFailList: Array<string> = [],
		ordsListToCancel: Array<string> = [];

	// runs after all cancel api response
	function cancelCallback(res: any) {
		if (res.data) {
			// if success
			ordCancelledSuccList.push(res.data);
		} else {
			// if error
			ordCancelledFailList.push(res.error);
		}

		// when we get all the responses
		if (ordCancelledSuccList.length + ordCancelledFailList.length === ordsListToCancel.length) {
			setShowCancelPopup(undefined); // close confirmation popup
			//show toast message
			ee.emit("showToast", { message: `Cancelled ${ordsListToCancel.length} Orders`, color: "cancell" });

			props.reRenderCall && props.reRenderCall("today");
		}
	}

	function checkPartialOrder(bulkCancel: boolean, data?: IEquity) {
		// <span>{data.flQty}</span>/<span>{data.ntQty ? data.ntQty : data.qtyTF}</span>
		const { flQtySum, ntQtySum } = addFlAndNtQty(bulkCancel, data);

		if (flQtySum === ntQtySum) {
			// not partially completed
			cancelOrder(bulkCancel, data?.ordID);
		} else {
			// partially completed
			setShowCancelPopup({ bulkCancel, data });
		}
	}

	function cancelOrder(bulkCancel: boolean, data?: any) {
		if (bulkCancel) {
			tableData.forEach((g: any) =>
				g.forEach((rw: IEquity) => {
					if (rw.isSelected) {
						ordsListToCancel.push(rw.ordID);
						if (props.isSip) {
							// if sip trade then run this api
							AEqCancelSIPOrd(cancelCallback, rw.ordID);
						} else if (rw.ogt === "AMO") {
							// if amo trade then run this api
							AEqCancelAmoTrd(cancelCallback, { nstOID: rw.ordID, exc: rw.exc, ordTyp: rw.ordTyp, prdCode: rw.prdCode });
						} else {
							// if normal trade then run this api
							AEqCancelNrmTrd(cancelCallback, { nstOID: rw.ordID, exc: rw.exc, ordTyp: rw.ordTyp, prdCode: rw.prdCode });
						}
					}
				})
			);
		} else if (data) {
			// cancel single order
			ordsListToCancel.push(data?.ordID);
			if (props.isSip) {
				// if sip trade then run this api
				AEqCancelSIPOrd(cancelCallback, data.ordID);
			} else if (data.ogt === "AMO") {
				// if amo trade then run this api
				AEqCancelAmoTrd(cancelCallback, { nstOID: data.ordID, exc: data.exc, ordTyp: data.ordTyp, prdCode: data.prdCode });
			} else {
				// if normal trade then run this api
				AEqCancelNrmTrd(cancelCallback, { nstOID: data.ordID, exc: data.exc, ordTyp: data.ordTyp, prdCode: data.prdCode });
			}
		}
	}

	function eqRow(data: IEquity, groupIndex: number, index: number) {
		return (
			<div className="eq_mob new_offers_mob_con" onClick={(e) => onRowClick(data, groupIndex, index, e)} key={index}>
				<div className="tag">
					{isSelectEnable ? (
						<ObCheckbox name="eqTradeSelect" checked={data.isSelected} onChange={() => selectRows(groupIndex, index)} />
					) : (
						<Tag
							value={data.trsTyp ? data.trsTyp[0] : ""}
							shape="mini_circle"
							color={data.trsTyp === "BUY" ? "green" : "red"}
							height="30px"
							width="30px"
						/>
					)}
				</div>
				<div className="new_offers_data">
					<div className="date">
						{isSelectEnable && <Tag value={data.trsTyp} cn="mob_text_tag" color={data.trsTyp === "BUY" ? "green" : "red"} />}
						{data.rcvTim && data.rcvTim}
						{data.ordEntTyp && moment(dateTimeFormat(data.ordEntTyp)).format("HH:mm:ss")}
					</div>
					<div className="comp_con">
						<div className="sym">
							<span dangerouslySetInnerHTML={{ __html: data.cpName ? data.cpName : data.dpName ? data.dpName : data.trdSym }}></span>
						</div>
						{data.sts && (
							<div className={"sts " + (ChipStatusComb[data.sts.toLowerCase()] === "amo" ? "tCU" : "")}>
								<Tag value={ChipStatusComb[data.sts.toLowerCase()]} color={ChipColorKeyComb[data.sts]} />
							</div>
						)}
					</div>
					<div className="new_offers_values">
						<div className="prod_value">
							<span className="prod_type pd-r10">{data.prdCode}</span>
							<span className="pd-r10">{data.ordTyp}</span>
							<span className="qty">{data.flQty}</span>/<span>{data.ntQty ? data.ntQty : data.qtyTF}</span>
						</div>
						<div className="amt">
							₹{numValChk(data.avgPrc) ? toINR(data.avgPrc, 2) : data.prc ? toINR(data.prc, 2) : toINR(data.prcTF, 2)}
						</div>
					</div>
				</div>
			</div>
		);
	}

	function CurRow(data: IEquity, groupIndex: number, index: number) {
		return (
			<div className="curr_mob new_offers_mob_con" onClick={(e) => onRowClick(data, groupIndex, index, e)} key={index}>
				<div className="tag">
					{isSelectEnable ? (
						<ObCheckbox name="eqTradeSelect" checked={data.isSelected} onChange={() => selectRows(groupIndex, index)} />
					) : (
						<Tag value={data.trsTyp[0]} shape="mini_circle" color={data.trsTyp === "BUY" ? "green" : "red"} height="30px" width="30px" />
					)}
				</div>
				<div className="new_offers_data">
					<div className="date">
						{isSelectEnable && <Tag value={data.trsTyp} cn="mob_text_tag" color={data.trsTyp === "BUY" ? "green" : "red"} />}
						{data.rcvTim && data.rcvTim}
						{data.ordEntTyp && moment(dateTimeFormat(data.ordEntTyp)).format("HH:mm:ss")}
					</div>
					<div className="comp_con">
						<div className="sym">
							<p dangerouslySetInnerHTML={{ __html: data.symName ? data.symName : data.cpName ? data.cpName : data.dpName }}></p>
							<p className="sym_code" dangerouslySetInnerHTML={{ __html: data.trdSym }}></p>
						</div>
						<div className="sts">
							<Tag value={ChipStatusComb[data.sts.toLowerCase()]} color={ChipColorKeyComb[data.sts]} />
						</div>
					</div>
					<div className="new_offers_values">
						<div className="prod_value">
							<span className="prod_type pd-r10">{data.prdCode}</span>
							<span>{toINR(data.ntQty ? data.ntQty : data.qtyTF, 0)}</span> Qty @ <span>₹{toINR(data.prc, 2)}</span>
						</div>
						<div className="amt">₹{toINR(data.avgPrc, 2)}</div>
					</div>
				</div>
			</div>
		);
	}

	function derRow(data: IEquity, groupIndex: number, index: number) {
		return (
			<div className="deriv_mob new_offers_mob_con" onClick={(e) => onRowClick(data, groupIndex, index, e)} key={index}>
				<div className="tag">
					{isSelectEnable ? (
						<ObCheckbox name="eqTradeSelect" checked={data.isSelected} onChange={() => selectRows(groupIndex, index)} />
					) : (
						<Tag value={data.trsTyp[0]} shape="mini_circle" color={data.trsTyp === "BUY" ? "green" : "red"} height="30px" width="30px" />
					)}
				</div>
				<div className="new_offers_data">
					<div className="date">
						{isSelectEnable && <Tag value={data.trsTyp} cn="mob_text_tag" color={data.trsTyp === "BUY" ? "green" : "red"} />}

						{data.rcvTim && data.rcvTim}
						{data.ordEntTyp && moment(dateTimeFormat(data.ordEntTyp)).format("HH:mm:ss")}
					</div>
					<div className="comp_con">
						<div className="sym">
							<p dangerouslySetInnerHTML={{ __html: data.symName ? data.symName : data.cpName ? data.cpName : data.dpName }}></p>
							<p className="sym_code" dangerouslySetInnerHTML={{ __html: data.trdSym }}></p>
						</div>
						<div className="sts">
							<Tag value={ChipStatusComb[data.sts.toLowerCase()]} color={ChipColorKeyComb[data.sts]} />
						</div>
					</div>
					<div className="new_offers_values">
						<div className="prod_value">
							<span className="prod_type pd-r10">{data.prdCode}</span>
							<span className="qty">{data.flQty}</span>/<span>{data.ntQty ? data.ntQty : data.qtyTF}</span>
						</div>
						<div className="amt">₹{data.avgPrc}</div>
					</div>
				</div>
			</div>
		);
	}

	function nonSip() {
		return (
			<div className="eq_wrap_mob">
				{props.isHistory
					? eqHistoryData.map((group: any, groupIndex: number) =>
							Object.keys(group).map((date: any, index: number) => {
								return (
									<React.Fragment key={index}>
										<ul className={scrlStCls.freeze + " eq_hist_date hist_date"} key={"dtGp" + index}>
											<li>{moment(dateTimeFormat(date)).format("DD MMMM YYYY")}</li>
										</ul>
										<ul className={scrlStCls.toContext} key={"dtUlDet" + index}>
											{group[date].map((row: any, index: number) => (
												<React.Fragment key={index}>
													{props.aType === "equity" && eqRow(row, groupIndex, index)}
													{props.aType === "currency" && CurRow(row, groupIndex, index)}
													{props.aType === "derivative" && derRow(row, groupIndex, index)}
												</React.Fragment>
											))}
										</ul>
									</React.Fragment>
								);
							})
					  )
					: !!tableData.length &&
					  tableData.map((group: any, groupIndex: number) => {
							return (
								<React.Fragment key={groupIndex}>
									{group.length > 0 && (
										<div key={groupIndex} className={"blockDivider child" + groupIndex}>
											{group.map((row: any, index: number) => (
												<React.Fragment key={index}>
													{props.aType === "equity" && eqRow(row, groupIndex, index)}
													{props.aType === "currency" && CurRow(row, groupIndex, index)}
													{props.aType === "derivative" && derRow(row, groupIndex, index)}
												</React.Fragment>
											))}
										</div>
									)}
								</React.Fragment>
							);
					  })}
				{!tableData.length && <TocNoData data={initialData} callBackMeth={onDataFilter} />}
			</div>
		);
	}

	//sip orders
	function sipOrders() {
		return (
			<>
				{!!tableData.length &&
					tableData.map((group: any, groupIndex: number) =>
						// Object.keys(group).map((grp: any, index) =>
						{
							return (
								<div className={"sip_mob_con"} key={groupIndex}>
									{group.map((item: IEqSip, index: number) => (
										<React.Fragment key={index}>
											<div className="tag">
												{/* <Tag value="B" shape="mini_circle" color="red" height="30px" width="30px" /> */}
											</div>
											<div className="sip_data_con">
												<div className="date">
													Next:
													<span className="dte">{moment(dateTimeFormat(item.spNDD)).format("DD MMM ’YY")}</span>
												</div>
												<div className="comp_con">
													<div className="comp">{item.tSym}</div>
													<div className="sts">{/* <Tag value="Pending" color="blue" /> */}</div>
												</div>
												<div className="sip_values">
													<div className="lft_val">
														<span>
															{item.sFrqy} ({GetNoOfDaysOrMonths(item.spNDD, item.spSD, item.sFrqy.toLowerCase())}/
															{GetNoOfDaysOrMonths(item.spLED, item.spSD, item.sFrqy.toLowerCase())})
														</span>
														<span className="amt_qty">
															<span>{toINR(item.spQty, 0)} </span>Qty
														</span>
													</div>
													<div className="rgt_val">{item.spAmt ? "₹" + toINR(item.spAmt, 0) : "--"}</div>
												</div>
											</div>
										</React.Fragment>
									))}
								</div>
							);
							// )
						}
					)}
				{!tableData.length && <TocNoData data={initialData} callBackMeth={onDataFilter} />}
			</>
		);
	}
	return (
		<div className="instMobView eq_wrap_mob">
			{!isSelectEnable && (
				<ObUtilHeader
					leftSideText={
						!props.isHistory && !props.isSip ? (
							<div className="executed">
								<span className="text">{props.isSip ? "Active SIPs" : "Executed Orders"}: </span>
								<span className="value">
									{!props.isSip ? exeCountRef.current + " /" : ""} {initialData[0].length}
								</span>
							</div>
						) : props.isHistory ? (
							<DatePickerInt plusDays={15} sendDates={props.getDates} />
						) : (
							<></>
						)
					}
					data={initialData}
					searchKey="cpName;dpName;trdSym;tSym"
					onDataFilter={onDataFilter}
					onSelectClick={
						!props.isHistory && tableData.find((g: any) => g.find((row: IEquity) => row.cancel === "true"))
							? () => {
									setIsSelectEnable(true);
									props.hidePageNav && props.hidePageNav(true);
							  }
							: undefined
					}
					filterReqData={{
						status: "sts",
						aType: props.aType,
						showOpenOrderOnTop: OpenOrdsTopRef.current,
						showOpenOrderTgl: props.isHistory || props.isSip ? false : true,
						isHistory: props.isHistory ? true : false
					}}
					onFilterClick={(tgl) => {
						OpenOrdsTopRef.current = tgl;
					}}
					onSearchClick={(e) => {
						setTableData(initialData);
						// if exists, then call it
						props.hidePageNav && props.hidePageNav(e);
					}}
				/>
			)}
			{isSelectEnable && (
				<>
					<div>
						<EdButton
							value={backButtonValue}
							btnTyp="link"
							onClick={() => {
								setIsSelectEnable(false);
								props.hidePageNav && props.hidePageNav(false);
							}}
							className="icon_button"
						/>

						<div className="toBtm">
							<EdButton
								type="button"
								btnTyp="primary"
								value="Cancel Orders"
								slim={false}
								disabled={selectedCount === 0 ? true : false}
								onClick={() => checkPartialOrder(true)}
							/>
						</div>
					</div>
				</>
			)}
			{isSelectEnable && (
				<div className="check_box">
					<ObCheckbox name="eqTradeSelect" checked={isAllDataSelected} onChange={() => selectRows(-1, -1)}>
						Select All
					</ObCheckbox>
				</div>
			)}
			<div className={props.data.length > 0 ? "ObScrollCont" : ""} style={ObScrollStyle(props.data.length > 0 ? true : false)}>
				{!props.isSip && nonSip()}
				{props.isSip && sipOrders()}
			</div>
			{/* tableData[groupIndex][index] */}
			{popupDataIndex && (
				<ObAssetDetailPopup>
					<ObEqDtlsOpenMob
						data={
							props.isHistory
								? eqHistoryData[popupDataIndex[0]][popupDataIndex[2]!][popupDataIndex[1]]
								: tableData[popupDataIndex[0]][popupDataIndex[1]]
						}
						onBackClick={() => setPopupDataIndex(undefined)}
						isTodayOrder={true}
						onCancelClick={() => checkPartialOrder(false, tableData[popupDataIndex[0]][popupDataIndex[1]] as IEquity)}
					/>
				</ObAssetDetailPopup>
			)}
			{showCancelPopup && (
				<ObAssetDetailPopup>
					<ObToastMessPopup
						title={`Cancel ${selectedRows(showCancelPopup.bulkCancel, showCancelPopup.data)} Orders`}
						subtitle={
							showCancelPopup.data.dur === "GTC" || showCancelPopup.data.dur === "GTD"
								? "This will also cancel the GTD/GTC order, are you sure you want to cancel order ?"
								: `${addFlAndNtQty(showCancelPopup.bulkCancel, showCancelPopup.data).flQtySum}/${
										addFlAndNtQty(showCancelPopup.bulkCancel, showCancelPopup.data).ntQtySum
								  } quantities have been partially executed. Are you sure you want to cancel the order?`
						}
						buttonValue="Yes, Confirm"
						btnTyp="secondary"
						onBackClick={() => setShowCancelPopup(undefined)}
						onToastBtnClick={() => cancelOrder(showCancelPopup.bulkCancel, showCancelPopup.data)}
					/>
				</ObAssetDetailPopup>
			)}
		</div>
	);
};

export default ObEquityMob;
